var render, staticRenderFns
import script from "./WxBtnIcon.vue?vue&type=script&lang=js"
export * from "./WxBtnIcon.vue?vue&type=script&lang=js"
import style0 from "./WxBtnIcon.vue?vue&type=style&index=0&id=3178e4d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178e4d3",
  null
  
)

export default component.exports